import {
    UPDATE_COMPLEX_MESSAGES,
    UPDATE_HEADER_GRAY_TITLE,
    UPDATE_HEADER_INFO,
    UPDATE_HEADER_TITLE,
    UPDATE_JS_MESSAGES,
    UPDATE_PAGE_MESSAGES,
} from 'actions/messageAction';

import update from 'helpers/Immutability';

const messages = (state = {}, action) => {
    let mergeState;
    switch (action.type) {
        case UPDATE_COMPLEX_MESSAGES:
            mergeState = update(state, {
                complexMessages: { $merge: action.complexMessages },
            });
            break;
        case UPDATE_PAGE_MESSAGES:
            mergeState = update(state, {
                pageMessages: { $merge: action.pageMessages },
            });
            break;
        case UPDATE_JS_MESSAGES:
            mergeState = update(state, {
                jsMessages: { $merge: action.jsMessages },
            });
            break;
        case UPDATE_HEADER_TITLE:
            mergeState = update(state, {
                pageMessages: {
                    $auto: {
                        headerTitle: { $set: action.headerTitle },
                    },
                },
            });
            break;
        case UPDATE_HEADER_INFO:
            mergeState = update(state, {
                pageMessages: {
                    $auto: {
                        headerInfo: { $set: action.headerInfo },
                    },
                },
            });
            break;
        case UPDATE_HEADER_GRAY_TITLE:
            mergeState = update(state, {
                pageMessages: {
                    $auto: {
                        headerGrayTitle: { $set: action.headerGrayTitle },
                    },
                },
            });
            break;
        default:
            return state;
    }
    return mergeState;
};
export default messages;
